//Reference https://www.codexworld.com/export-html-to-word-doc-docx-using-javascript/#:~:text=The%20Export2Word()%20function%20converts,ID%20to%20export%20content%20from.
function exportHTMLtoPDF(element, username = ''){

    window.jsPDF = window.jspdf.jsPDF;

    // Convert HTML content to PDF
    let doc = new jsPDF('l');

    let email = $('.learner-email')
    if(email){
        email.text(window.glasshouseEmail)
    }
    // Source HTMLElement or a string containing HTML.
    let elementHTML = document.querySelector(element);

    
    doc.html(elementHTML, {
        callback: function(doc) {
            // Save the PDF
            doc.save('export.pdf');
        },
        margin: [10, 10, 10, 10],

        x: 30,
        y: 0,
        orientation:'l',
        width: 200, //target width in the PDF document
        windowWidth: 800 //window width in CSS pixels
    
    });
}
window.exportHTMLtoPDF = exportHTMLtoPDF


// WEBPACK FOOTER //
// Glasshouse/Core/js/exportHTMLtoPdf.js